<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/production/woreportrecord/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form class="demo-form-inline" :inline="true">
          <el-form-item :label="$t('mujubianhao') + ':'">
            {{ mouldNo }}
          </el-form-item>

          <el-form-item :label="$t('shebeimingcheng') + ':'">
            {{ equipmentName }}
          </el-form-item>

          <el-form-item :label="$t('shangmoshijian') + ':'">
            {{ dayjs(upMoldTime).format('YYYY-MM-DD HH:mm:ss') }}
          </el-form-item>

          <el-form-item :label="$t('xiamoshijian') + ':'">
            {{ dayjs(lowerMoldTime).format('YYYY-MM-DD HH:mm:ss') }}
          </el-form-item>
        </el-form>

        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.productionNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shifoubulu')">
            <el-select v-model="yt.conditions.type">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="clear()">{{ $t('chongzhi') }} </el-button>
          </el-form-item>
        </el-form>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
import dayjs from 'dayjs';
export default {
  name: 'mold_up_down_report_list',
  props: {
    mouldId: {
      required: true
    },
    mouldNo: {
      required: true
    },
    equipmentId: {
      required: true
    },
    equipmentName: {
      required: true
    },
    upMoldTime: {
      required: true
    },
    lowerMoldTime: {
      required: true
    }
  },
  data() {
    return {
      columns: [
        {
          label: 'shengchangongdanhao',
          prop: 'productionNo',
          width: 130
        },
        {
          label: 'baogongdanhao',
          prop: 'woReportRecordNo',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'materialCode',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName',
          width: 130
        },
        {
          label: 'guige',
          prop: 'materialObject.spec',
          width: 130
        },
        {
          label: 'gongxumiaoshu',
          prop: 'procedureDesc',
          width: 130
        },

        {
          label: 'baogongshuliang',
          prop: 'quantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'goodQuantity',
          width: 130
        },
        {
          label: 'buliangshuliang',
          prop: 'badQuantity',
          width: 130
        },
        {
          label: 'jiqijilushuliang',
          prop: 'machineQuantity',
          width: 130
        },
        //补充列
        {
          label: 'moqiangshu',
          prop: 'cavity',
          width: 130
        },
        //补充列
        {
          label: this.$t('biaozhunzhouqi(miao/mu)'),
          prop: 'standardCycle',
          width: 180
        },
        //补充列
        {
          label: this.$t('pingjunzhouqi(miao/mu)'),
          prop: 'cycle',
          width: 180
        },

        {
          label: 'caozuoren',
          prop: 'createByObject.nickname',
          width: 130
        },
        {
          label: 'xiezuoren',
          prop: 'collaborator',
          width: 150
        },
        {
          label: 'tibaoshijian',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'shifoubulu',
          prop: 'type',
          type: 'slot',
          width: 130
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      let mouldIds = [];
      mouldIds.push(this.mouldId);
      let equipmentIds = [];
      equipmentIds.push(this.equipmentId);
      this.yt.conditions.mouldIds = mouldIds;
      this.yt.conditions.equipmentIds = equipmentIds;
      this.yt.get(1);
    }, 300);
  },
  methods: {
    clear() {
      this.yt.conditions.productionNo = null;
      this.yt.conditions.materialIds = [];
      this.yt.conditions.type = null;
      this.yt.get(1);
    }
  }
};
</script>
